module.exports = __webpack_public_path__ + "img/look.3fc9d0d9.png";